export const SET_WIDGET_TITLE = 'setWidgetTitle';
export const GET_PUBLISHERS = 'getPublishers';
export const GET_PUBLISHER = 'getPublisher';
export const GET_PUBLISHERS_STATS = 'getPublishersStats';
export const CREATE_PUBLISHER = 'createPublisher';
export const UPDATE_PUBLISHER = 'updatePublisher';
export const GET_PUBLISHER_REFERENCES = 'getPublisherReferences';
export const DELETE_PUBLISHER = 'deletePublisher';
export const GET_USER_VISIBLE_COLUMNS = 'getUserVisibleColumns';
export const SAVE_PUBLISHER = 'savePublisher';
export const SET_INVITES_FOR_PUBLISHER = 'setInvitesForPublisher';
export const SET_SHOW_NEW_PUBLISHER_INVITES = 'setShowNewPublisherInvites';
export const GET_ACCOUNT_SETTINGS = 'getAccountSettings';